export default __webpack_public_path__ + "static/media/hockeyrink1.01b7f3fd.jpg";